import DuplicateValidationModal from './duplicateValidationModal.view';

export default DuplicateValidationModal;
